import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

const setVendorizedProductName = () => {
  const vendorizedProductName = i18n.t(process.env.REACT_APP_PRODUCT_NAME);
  i18n.options.interpolation.defaultVariables = { vendorizedProductName };
};

const SUPPORTED_LANGUAGES = ['en', 'ja'];

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(resourcesToBackend((language, namespace) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'vendor',
    ns: ['vendor'],
    react: {
      useSuspense: false
    },
    detection: {
      order: ['navigator'],
      caches: []
    }
  }).then(() => document.documentElement.lang = i18n.language);

// Dynamically set the vendorizedProductName after initialization
i18n.on('initialized', setVendorizedProductName);
i18n.on('languageChanged', setVendorizedProductName);

export function getLocalizedValue(key, namespace, options = {}) {
  if (i18n.language && namespace && !i18n.hasLoadedNamespace(namespace)) {
    try {
      const lang = SUPPORTED_LANGUAGES.includes(i18n.language) ? i18n.language : 'en';
      i18n.addResourceBundle(lang, namespace, require(`./locales/${lang}/${namespace}.json`),false, true);
    }
    catch (e) {
      console.log(e);
    }
  }
  return i18n.t(key, { ns: namespace, ...options });
}

export default i18n;